module.exports = {"name":"Otvorené hlasovania v kategórii - detail","icon":"<i class='material-icons'>library_books</i>","widget":{"type":"category-hlasludu-personal-detail-open","initData":{"tags":[],"limit":6}}}


//////////////////
// WEBPACK FOOTER
// ./src/blocks/category-hlasludu-personal-detail-open/category-hlasludu-personal-detail-open.json
// module id = 306
// module chunks = 0